import type { ButtonHTMLAttributes } from 'react';
import { twJoin } from 'tailwind-merge';

import { ButtonView, type ButtonViewProps } from './ButtonView';

export type BaseButtonProps = ButtonViewProps & {
  onClick?: () => void;
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  full?: boolean;
  onMouseDown?: ButtonHTMLAttributes<HTMLButtonElement>['onMouseDown'];
  form?: ButtonHTMLAttributes<HTMLButtonElement>['form'];
};

export const BaseButton = ({
  children,
  onClick,
  isDisabled,
  isLoading,
  type,
  className,
  leftElement,
  rightElement,
  full,
  variant,
  contentStretch,
  size,
  onMouseDown,
  form,
}: BaseButtonProps) => {
  return (
    <button
      className={twJoin(full && 'w-full')}
      onClick={onClick}
      type={type ?? 'button'}
      disabled={isDisabled || isLoading}
      onMouseDown={onMouseDown}
      form={form}
    >
      <ButtonView
        isLoading={isLoading}
        leftElement={leftElement}
        rightElement={rightElement}
        className={className}
        isDisabled={isDisabled && !!onClick}
        variant={variant}
        contentStretch={contentStretch}
        size={size}
      >
        {children}
      </ButtonView>
    </button>
  );
};
